import type { Theme } from '@monorepo/theme'

export type ThemeMode = 'light' | 'dark' | 'system'
export type { Theme } from '@monorepo/theme'

export const RELAYABLY_THEME_STORAGE_KEY = 'relayably-theme-mode'

export const relayablyTypography = {
  regular: { fontFamily: 'System', fontWeight: '400' as const },
  medium: { fontFamily: 'System', fontWeight: '500' as const },
  bold: { fontFamily: 'System', fontWeight: '700' as const },
  heavy: { fontFamily: 'System', fontWeight: '900' as const },
}

const shared = {
  spacing: {
    xs: 4,
    s: 8,
    m: 16,
    l: 24,
    xl: 40,
  },
  radii: {
    xs: 4,
    s: 8,
    m: 16,
    l: 24,
    xl: 40,
  },
  widths: {
    xxxs: 24,
    xxs: 40,
    xs: 100,
    s: 200,
    m: 300,
    l: 400,
    xl: 500,
    xxl: 800,
  },
  fontSizes: {
    xs: 8,
    s: 10,
    m: 12,
    l: 16,
    xl: 20,
  },
  fonts: relayablyTypography,
}

export const relayablyLightTheme: Theme = {
  dark: false,
  colors: {
    staticWhite: '#ffffff',
    staticBlack: '#000000',
    staticFacebook: '#0866ff',
    primary: '#4f46e5',
    secondary: '#7c3aed',
    tertiary: '#9333ea',
    quarternary: '#c026d3',
    background: '#ffffff',
    surface: '#f9fafb',
    card: '#ffffff',
    text: '#18181b',
    textReversed: '#f9fafb',
    inactive: '#71717a',
    border: '#e4e4e7',
    notification: '#ef4444',
    error: '#ef4444',
    warning: '#f59e0b',
    positive: '#10b981',
  },
  ...shared,
}

export const relayablyDarkTheme: Theme = {
  dark: true,
  colors: {
    staticWhite: '#ffffff',
    staticBlack: '#000000',
    staticFacebook: '#0866ff',
    primary: '#818cf8',
    secondary: '#a78bfa',
    tertiary: '#c084fc',
    quarternary: '#e879f9',
    background: '#09090b',
    surface: '#18181b',
    card: '#111114',
    text: '#fafafa',
    inactive: '#a1a1aa',
    border: 'rgba(255,255,255,0.1)',
    notification: '#f87171',
    error: '#f87171',
    warning: '#fbbf24',
    positive: '#34d399',
  },
  ...shared,
}

export const relayablyThemes = {
  light: relayablyLightTheme,
  dark: relayablyDarkTheme,
}

export const getRelayablyTheme = (mode: Exclude<ThemeMode, 'system'>) => relayablyThemes[mode]
